import { cva } from "class-variance-authority";

export const tabListStyles = cva([
    "relative flex w-full items-stretch overflow-hidden rounded-md pb-[3px]",
    "divide-x",
], {
    variants: {
        variant: {
            default: "border border-border bg-white divide-border",
            switcher: "border border-[#d8e4ef] bg-[#f7fbff] divide-[#d8e4ef]",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

export const tabButtonStyles = cva(
    [
        "flex w-full items-center justify-center gap-2 px-3 font-medium",
        "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#3174a3]/40",
        "disabled:cursor-not-allowed disabled:opacity-50",
    ],
    {
        variants: {
            isActive: {
                true: "text-foreground",
                false: "text-muted-foreground hover:text-foreground hover:bg-muted/40",
            },
            size: {
                sm: "py-2 text-xs",
                md: "py-2.5 text-sm",
                lg: "py-3 text-base",
            },
            variant: {
                default: "",
                switcher: "text-[14px]",
            },
        },
        defaultVariants: {
            size: "md",
            variant: "default",
        },
    },
);

export const tabLabelStyles = cva([
    "whitespace-nowrap",
]);

export const tabIndicatorStyles = cva([
    "pointer-events-none absolute bottom-0 left-0 block h-[3px] z-10",
    "transition-transform duration-200 ease-out",
], {
    variants: {
        variant: {
            default: "",
            switcher: "",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

export const tabIndicatorInnerStyles = cva([
    "block h-full w-full rounded-sm bg-[#3174a3]",
    "origin-center transition-transform duration-200 ease-out",
], {
    variants: {
        variant: {
            default: "",
            switcher: "bg-[#2f74a4]",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

